import { FC } from "react";
import ReactDomServer from "react-dom/server";

import { IFormSettings } from "./../../../../../services/forms";
import { IEmailEditorData } from "../../../../../store/settings/types";
import { PopupTypes } from "./../../../../../store/types/Popup";
import usePopup from "./../../../../../hooks/usePopup";
import Button, { ButtonVariant } from "./../../../../../libs/Button";
import AllRightReserved from "./AllRightsReserved";
import Icon, { IconTypes } from "./../../../../../libs/Icon";

import styles from "./styles.module.scss";

interface IProps {
    handleChange: (newValue: IEmailEditorData) => void;
    invoiceInitial: IEmailEditorData;
    addMoreAnswer?: IFormSettings["confirmation"]["afterSubmit"]["addMoreAnswer"];
    downloadPDF?: IFormSettings["confirmation"]["afterSubmit"]["downloadPDF"];
    editAnswer?: IFormSettings["confirmation"]["afterSubmit"]["editAnswer"];
}

const NotificationTextEditor: FC<IProps> = ({
    handleChange,
    invoiceInitial,
    addMoreAnswer,
    downloadPDF,
    editAnswer,
}) => {
    const { onOpen: onPopupOpen } = usePopup();
    const footer: string = ReactDomServer.renderToString(<AllRightReserved />);

    return (
        <>
            <div className={styles.richEditorContainer}>
                <Button
                    className={styles.customize}
                    text="Customize"
                    variant={ButtonVariant.LINED_PRIMARY}
                    onClick={() => onPopupOpen(PopupTypes.EMAIL_EDITOR, handleChange, invoiceInitial)}
                />

                <div dangerouslySetInnerHTML={{ __html: `${invoiceInitial.html}` }} />

                <div className={styles.message}>
                    <div className={styles.extraOptions}>
                        {editAnswer?.isActive && (
                            <span>
                                <Icon type={IconTypes.EDIT} size={20} />
                                <span>{editAnswer.buttonLabel}</span>
                            </span>
                        )}
                        {addMoreAnswer?.isActive && (
                            <span>
                                <Icon type={IconTypes.FILL_AGAIN} size={20} />
                                <span>{addMoreAnswer.buttonLabel}</span>
                            </span>
                        )}
                        {downloadPDF?.isActive && (
                            <span>
                                <Icon type={IconTypes.DOWNLOAD_PDF} size={20} />
                                <span>{downloadPDF.buttonLabel}</span>
                            </span>
                        )}
                    </div>
                </div>

                <div dangerouslySetInnerHTML={{ __html: footer }} />
            </div>
        </>
    );
};

export default NotificationTextEditor;
